export default __webpack_public_path__ + "static/media/citate.cbce6411.jpg";